import dayjs, { Dayjs } from 'dayjs';

export const convertToDayJs = (date?: unknown): Dayjs => {
  return dayjs(date as string);
};

export const convertDayJsToString = (date: Dayjs, format: string): string => {
  return date.format(format);
};
